import React from 'react';
import { alpha, Theme, useTheme } from '@mui/material/styles';
import colorName from 'color-name';

import { StyledLabel } from '../label/styles';

interface Props {
  text: string;
  textColor: string;
}

type ColorNameMap = Record<string, [number, number, number]>;

const getHexColor = (color: string | undefined, colorMap: ColorNameMap, theme: Theme): string => {
  if (!color || !colorMap[color.toLowerCase()]) {
    return color ?? theme.palette.common.black;
  }

  const rgb = colorMap[color.toLowerCase()] as [number, number, number];
  return `#${rgb.map((x) => x.toString(16).padStart(2, '0')).join('')}`;
};

const TaskStatus: React.FC<Props> = ({ text, textColor }) => {
  const theme = useTheme();
  const textColorHex = getHexColor(textColor, colorName, theme);

  let backgroundColor = theme.palette.common.white;

  if (textColorHex) {
    backgroundColor = alpha(textColorHex, 1);
  }

  return (
    <StyledLabel
      sx={{ backgroundColor, color: textColorHex, fontSize: '10px' }}
      theme={theme}
      ownerState={{
        color: 'default',
        variant: 'filled',
      }}
    >
      {text}
    </StyledLabel>
  );
};

export default TaskStatus;
